import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import NutritionEditorActionsMenu from "./NutritionEditorActionsMenu";
import { buildNutritionEditorActionItems } from "./nutritionEditorActions";

function NutritionEditorDuplicateMenu({ onDuplicate = null }) {
  const { t } = useTranslation();
  const menuItems = useMemo(
    () =>
      buildNutritionEditorActionItems({
        t,
        includeDuplicate: true,
      }),
    [t],
  );

  if (typeof onDuplicate !== "function") {
    return null;
  }

  return (
    <NutritionEditorActionsMenu
      items={menuItems}
      onAction={() => onDuplicate()}
    />
  );
}

export default NutritionEditorDuplicateMenu;
